import { render } from "./DoughnutChart.vue?vue&type=template&id=73d98280&scoped=true"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"

import "./DoughnutChart.vue?vue&type=style&index=0&id=73d98280&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d98280"]])

export default __exports__